<template>
    <div id="app">
        <router-view />
        <div class="botText">
            <p>湖北云雷信息技术有限公司 版权所有 ©www.siisoo.com <a target="_blank" href="https://beian.miit.gov.cn/" >鄂ICP备15021347号-1</a> | 增值电信业务经营许可证： 鄂B2-20200549</p>
            <p>公司地址：武汉市东湖新技术开发区茅店山中路5号武钢高新技术产业园9号楼15层1501 <span class="phoneNumber">联系电话：027-87774447</span></p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'App',

  mounted () {
    function checkIE () {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.botText{
    position: fixed;
    bottom:0;
    left:0;
    width: 100%;
    padding:10px 0;
    background:rgba(0,0,0,.1);
}
.botText>p{
    line-height: 30px;
    padding: 0;
    margin: 0;
}
p>a{
    color:#2c3e50;
    text-decoration: none;
}
p>a:hover {
    color: #f80;
    text-decoration: none;
}
.phoneNumber{
    margin-left: 10px;
}
.el-carousel {
  height: 100%;
}
.el-carousel__arrow {
  color: #62c3d0 !important;
  border: none !important;
  margin: auto 2% !important;
  height: 17% !important;
  width: 3% !important;
  cursor: pointer !important;
  -webkit-transition: 0.3s !important;
  transition: 0.3s !important;
  border-radius: 10% !important;
  background-color: rgba(31, 45, 61, 0.11) !important;
  position: absolute !important;
  top: 50% !important;
  z-index: 10 !important;
  -webkit-transform: translateY(-50%) !important;
  transform: translateY(-50%) !important;
  text-align: center !important;
  font-size: 50px !important;
  transform: scale(1, 1.3) !important;
}
.el-carousel__arrow--left {
  background: linear-gradient(to right, #d5edfb, #eeffff) !important;
}
.el-carousel__arrow--right {
  background: linear-gradient(to right, #eeffff, #d5edfb) !important;
}
.el-carousel__container {
  position: relative;
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue